import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppstoreOutlined, DeleteOutlined, InfoCircleOutlined, MenuOutlined } from '@ant-design/icons';
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Alert, Avatar, Button, Space, Typography } from 'antd';
import { getMediaStore } from 'core/modules/media/media.store';
import { useTranslation } from 'react-i18next';
import { TaskReferenceView } from 'src/components/Tasks/Reference';
import { TaskZoneTag } from 'src/components/Tasks/ZoneTag';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RoutesUpdateTasksModalTasksList = function RoutesUpdateTasksModalTasksList(_ref) {
  var tasks = _ref.tasks,
      onTasksChange = _ref.onTaskIdsChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));

  var handleDragEnd = function handleDragEnd(event) {
    var active = event.active,
        over = event.over;

    if (active.id !== over.id) {
      var oldIndex = tasks.findIndex(function (item) {
        return item.id === active.id;
      });
      var newIndex = tasks.findIndex(function (item) {
        return item.id === over.id;
      });
      onTasksChange(arrayMove(tasks, oldIndex, newIndex).map(function (it) {
        return it.id;
      }));
    }
  };

  var onDeleteTask = function onDeleteTask(id) {
    onTasksChange(tasks.filter(function (it) {
      return it.id !== id;
    }).map(function (it) {
      return it.id;
    }));
  };

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Alert, {
      icon: /*#__PURE__*/_jsx(InfoCircleOutlined, {}),
      showIcon: true,
      message: t('route.tasks.rearrange.help'),
      description: t('route.tasks.rearrange.helpDescription')
    }), /*#__PURE__*/_jsx(DndContext, {
      sensors: sensors,
      collisionDetection: closestCenter,
      onDragEnd: handleDragEnd,
      children: /*#__PURE__*/_jsx(SortableContext, {
        items: tasks,
        strategy: verticalListSortingStrategy,
        children: tasks.map(function (it, index) {
          return /*#__PURE__*/_jsx(SortableItem, {
            task: it,
            index: index,
            onDelete: function onDelete() {
              return onDeleteTask(it.id);
            }
          }, it.id);
        })
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "TasksList__Container",
  componentId: "sc-7ps6q4-0"
})([""]);
export var SortableItem = function SortableItem(_ref2) {
  var task = _ref2.task,
      index = _ref2.index,
      onDelete = _ref2.onDelete;

  var _useSortable = useSortable({
    id: task.id
  }),
      attributes = _useSortable.attributes,
      listeners = _useSortable.listeners,
      setNodeRef = _useSortable.setNodeRef,
      transform = _useSortable.transform,
      transition = _useSortable.transition;

  var _getMediaStore = getMediaStore(),
      getCompanyMediaSrc = _getMediaStore.getCompanyMediaSrc;

  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  return /*#__PURE__*/_jsxs(ItemContainer, {
    style: style,
    children: [/*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
      className: "sortable",
      ref: setNodeRef
    }, attributes), listeners), {}, {
      children: /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(MenuOutlined, {}), /*#__PURE__*/_jsx(Typography.Text, {
          children: index + 1
        }), /*#__PURE__*/_jsx(Avatar, {
          src: getCompanyMediaSrc(task.content.company),
          icon: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
          size: 24
        }), /*#__PURE__*/_jsx(TaskReferenceView, {
          task: task
        }), /*#__PURE__*/_jsx(TaskZoneTag, {
          task: task
        })]
      })
    })), /*#__PURE__*/_jsx(Button, {
      type: "link",
      danger: true,
      onClick: onDelete,
      children: /*#__PURE__*/_jsx(DeleteOutlined, {})
    })]
  });
};
var ItemContainer = styled.div.withConfig({
  displayName: "TasksList__ItemContainer",
  componentId: "sc-7ps6q4-1"
})(["position:relative;.sortable{padding:12px;margin:12px;box-shadow:0 1px 4px #3336;border-radius:4px;background:white;cursor:move;padding-right:10px;}.ant-btn{position:absolute;right:6px;bottom:5px;}"]);